import React, { useEffect } from 'react';
import './GeneralDocs.css';

const Mouse = () => {
  useEffect(() => {
    // Scroll to the element with the ID in the URL fragment
    const hash = window.location.hash; // e.g., "#splitlead" or "#gazelead"
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, []); // Runs when the component mounts

  return (
    <div className="docs-page-container">
      <h1>Moving the Cursor</h1>
      <p>
        FaceLead comes with two built-in options to move the cursor: GazeLead and SplitLead. You can also use a third-party option without any constraint.
      </p>

      <div id="splitlead"></div>
      <h1 >SplitLead</h1>
      <p>
        SplitLead comes as a built-in mode. When you switch to SplitLead mode, the cursor will automatically move to the middle of the screen. From there, you can move right, left, up, or
        down. 
      </p>
      <h2>How it works?</h2>
      <p>
        The algorithm works this way: every time you move on a specific axis (up-down or left-right), the distance the cursor moves will be half of the distance of the
        previous move. The first axis move will move the cursor 1/4 of the screen height or width. Running the Center Mouse Instruction will restart the mode.
      </p>

      <div id="gazelead"></div>
      <h1>GazeLead</h1>
      <p>
        GazeLead is an eye-tracker mouse powered by AI. It can get activated through a Mouse Instruction
        (Modes → Add → Mouse → GazeLead). Once activated, GazeLead will determine the position of the mouse based on your gaze.
      </p>
      <p>
        You can start using GazeLead without any training, but custom user training will generally increase model's precision.
      </p>

      <h2>Training GazeLead</h2>
      <p>
        Go to the Train GazeLead menu and click on the <strong>Start training</strong> button to begin training.
        Keep your gaze on the dots once they appear. The recording will occur when the dot turns green.
      </p>
      <p>
        <strong>Caution:</strong> Blinking during the recording (while the dot is green) will cause underperformance of the model. If you realize you
        have blinked, consider removing the dot.
      </p>
    </div>
  );
};

export default Mouse;
